import EmployeesTableItem from "./EmployeesTableItem";

export default EmployeesTableItem;
